export default __webpack_public_path__ + "static/media/icon_data.4bcebfe3.png";